import api from "../../../api/api";

const getLocationPath = (locationId) =>{
    return new Promise((resolve, reject)=>{
        api.get("/location-manager/full-path/"+locationId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
        }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
        })
    })
}

const locationPathServices = {
    getLocationPath
}

export default locationPathServices